import {
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
  useTheme,
} from '@mui/material'
import { useContext, useState } from 'react'
import { MdEmail } from 'react-icons/md'
import { useLocation, useNavigate } from 'react-router-dom'
import { GlobalContext } from '../../App'
import { login } from '../../components/api.ts'
import PasswordField from '../../components/PasswordField/PasswordField'

const Login = ({ setTela, setTelaValidaToken }) => {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()

  const { verificaLogin } = useContext(GlobalContext)

  const [usuario, setUsuario] = useState('')
  const [loading, setLoading] = useState(false)
  const [senha, setSenha] = useState('')

  const logar = async () => {
    setLoading(true)
    const response = await login(usuario, senha)
    if (response.status) {
      if (response.aguardandoConfEmail) {
        setTelaValidaToken({ open: true, idUsuario: response.idUsuario })
        setTela('cadastro')
      } else {
        document.cookie = `token=${response.token}; path=/; SameSite=Lax`
        delete response.status
        verificaLogin(response, navigate, location)
        navigate(response.programa || '/')
      }
    }
    setLoading(false)
  }

  const handleUsuario = (e) => setUsuario(e.target.value)
  const handleSenha = (e) => setSenha(e.target.value)

  const handleEnter = (e) => {
    if (e.key === 'Enter') logar()
  }

  return (
    <>
      <Grid item xs={12}>
        <TextField
          onKeyDown={handleEnter}
          InputLabelProps={{ shrink: true }}
          fullWidth
          variant="outlined"
          margin="dense"
          size="small"
          label="Email"
          value={usuario}
          onChange={handleUsuario}
          autoFocus
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <MdEmail fontSize={24} fill={theme.palette.action.active} />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PasswordField
          InputLabelProps={{ shrink: true }}
          onKeyDown={handleEnter}
          fullWidth
          size="small"
          variant="outlined"
          margin="dense"
          label="Senha"
          value={senha}
          onChange={handleSenha}
        />
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          endIcon={
            loading ? <CircularProgress color="inherit" size={15} /> : null
          }
          disabled={loading}
          onClick={logar}
        >
          Iniciar sessão
        </Button>
      </Grid>
    </>
  )
}

export default Login
